import React, { useEffect, useState } from "react";
import { Routes, Route } from "react-router-dom";
import "./LoyaltyPage.css";
import { fetchLoyaltyOffers } from "../LoyaltyAPI/LoyaltyAPI";
import LoyaltyOfferFilterBar, {
  filterOffers,
  searchOffers,
} from "../LoyaltyOfferFilterBar/LoyaltyOfferFilterBar";
import LoyaltyOfferGrid from "../LoyaltyOfferGrid/LoyaltyOfferGrid";
import OfferDetail from "../OfferDetail/OfferDetail";
import LoyaltyBreadcrumbs from "../LoyaltyBreadcrumbs/LoyaltyBreadcrumbs";
import { useTranslation } from "react-i18next";

export default function LoyaltyPage() {
  const [offers, setOffers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filters, setFilters] = useState({ location: "", category: "" });
  const [searchQuery, setSearchQuery] = useState("");
  const { t } = useTranslation();

  useEffect(() => {
    async function loadOffers() {
      try {
        const data = await fetchLoyaltyOffers();
        setOffers(data);
      } catch (error) {
        console.error("Failed to load offers:", error);
      } finally {
        setLoading(false);
      }
    }

    loadOffers();
  }, []);

  if (loading) {
    return <p>{t("loading_offers")}</p>;
  }

  // Apply filters and search
  let processedOffers = filterOffers(offers, filters);
  processedOffers = searchOffers(processedOffers, searchQuery);

  return (
    <div className="loyalty-page">
      <h1 className="loyalty-heading">{t("loyaltyProgram.title")}</h1>
      <p className="loyalty-subheading">{t("loyaltyProgram.subtitle")}</p>

      <Routes>
        {/* List view with filter and grid */}
        <Route
          index
          element={
            <>
              <LoyaltyBreadcrumbs />
              <LoyaltyOfferFilterBar
                filters={filters}
                onFilterChange={setFilters}
                searchQuery={searchQuery}
                onSearchChange={setSearchQuery}
                totalOffers={offers.length}
                filteredCount={processedOffers.length}
              />
              <LoyaltyOfferGrid offers={processedOffers} />
              <p className="disclaimer-text">{t("disclaimer_text")}</p>
            </>
          }
        />

        {/* Detail view */}
        <Route
          path=":id"
          element={<OfferDetail offers={offers} />}
        />
      </Routes>
    </div>
  );
}
